import { useBaseProps } from '@hoc/withBaseProps';
import SkipLink from '@stories/Components/General/SkipLink/SkipLink';
import * as React from 'react';
import S from './SectionWrapper.styles';
const SectionWrapper = React.forwardRef((props, ref) => {
    const { children, layout = 'default', flush = 'none', variant = 'none', removeSkipLink, ...otherProps } = props;
    const baseProps = useBaseProps();
    return (React.createElement(S.Container, { ref: ref, id: baseProps.id, "data-allow-scroll-margin": !!baseProps.id, "data-flush": flush, "data-variant": variant, "data-has-skip": !removeSkipLink, ...otherProps },
        React.createElement(S.Inner, null,
            !removeSkipLink ? React.createElement(SkipLink, null) : React.createElement(S.FocusAnchor, { "aria-label": "Skip to content anchor" }),
            renderLayout())));
    function renderLayout() {
        if (layout === 'fullWidth') {
            return children;
        }
        return React.createElement(S.SiteWide, null, children);
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
